export interface ConvertTo12HourProps {
  includePeriod?: boolean;
}

export const convertTo12Hour = (
  time: string,
  { includePeriod = false }: ConvertTo12HourProps = {},
): string => {
  const groups = /(?<hour>\d+)(:(?<minute>\d+))?/.exec(time)?.groups;

  if (!groups?.hour) return time;

  const hour24 = Number(groups.hour);
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;

  let result = String(hour12);

  if (groups.minute)
    result += ':' + groups.minute;


  if (includePeriod) {
    const period = hour24 < 12 ? 'AM' : 'PM';
    result += ' ' + period;
  }

  return result;
};

export const convertTo24Hour = (time: string): string => {
  const groups = /(?<hour>\d*)(:(?<minute>\d*))?( (?<period>AM|PM))?/.exec(time)
    ?.groups;

  let result = '';
  if (groups?.hour) {
 result += `${
      (+groups.hour + (groups?.period === 'PM' ? 12 : 0)) % 24
    }`.padStart(2, '0');
}
  if (groups?.minute) result += ':' + groups.minute;

  return result;
};

export const convertToSeconds = (time: string): number => {
  const groups = /(?<hour>\d*)(:(?<minute>\d*))( (?<period>AM|PM))/.exec(time)
    ?.groups;

  let result = 0;
  if (groups?.hour) {
 result +=
      (((+groups.hour % 12) + (groups?.period === 'PM' ? 12 : 0)) % 24) *
      60 *
      60;
}
  if (groups?.minute) result += +groups.minute * 60;

  return result;
};
